import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const steps = [
  { icon: FiIcons.FiPlayCircle, title: "Watch Stories", desc: "Cinematic animated explanations." },
  { icon: FiIcons.FiSliders, title: "Interactive Visuals", desc: "Drag sliders, see concepts respond." },
  { icon: FiIcons.FiEdit3, title: "Guided Practice", desc: "Step-wise hints and video solutions." },
  { icon: FiIcons.FiCode, title: "Build Projects", desc: "Apply what you learn creatively." },
];

const Methodology = () => {
  return (
    <section className="py-20 bg-slate-950 border-y border-slate-900">
      <div className="container mx-auto px-6">
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-slate-100 mb-4">How Learning Feels</h2>
          <p className="text-slate-400">Every course inside the portal follows the same simple, effective loop.</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {steps.map((step, idx) => (
            <div key={idx} className="flex flex-col gap-4">
              <div className="text-cyan-500 text-3xl">
                <SafeIcon icon={step.icon} />
              </div>
              <div>
                <h4 className="text-lg font-bold text-slate-200 mb-1">{step.title}</h4>
                <p className="text-sm text-slate-500">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Methodology;